/* eslint-disable */
import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { Px } from '../assets/posize';
import HeaderBlack from '../components/HeaderBlack';

export default function SOUL5(props) {
  return (
    <div
      style={{
        '--src': `url(${
          require('assets/9cce8c4716386be4bdf4bed47955b819.png').default
        })`
      }}
      className={`s-ou-l5 ${css(styles.group, styles.group_layout)}`}
    >
      <div className={css(styles.group1, styles.group1_layout)}>
        <div className={css(styles.flex, styles.flex_layout)}>
          <div className={css(styles.flex_item)}>
            <div className={css(styles.component, styles.component_layout)}>
              <HeaderBlack
                icon={
                  require('assets/d322d14b233070bbff024a1a56d1eb66.png').default
                }
                image={
                  require('assets/c6b10e4947e78c4196251481415c35c3.png').default
                }
              />
            </div>
          </div>
          <div className={css(styles.flex_item1)}>
            <div
              style={{
                '--src': `url(${
                  require('assets/66ff20f3aa3cff6d1dfe0802763fe392.png').default
                })`
              }}
              className={css(styles.cover_group, styles.cover_group_layout)}
            >
              <div
                style={{
                  '--src': `url(${
                    require('assets/aae128c32ea232e51a55c4b0de185313.png')
                      .default
                  })`
                }}
                className={css(styles.image, styles.image_layout)}
              />
            </div>
          </div>
          <h4 className={css(styles.highlights, styles.highlights_layout)}>
            {'你/妳的靈魂是'}
          </h4>
          <h1 className={css(styles.big_title, styles.big_title_layout)}>
            {'山林裡的個性智者'}
          </h1>
          <div className={css(styles.flex_item2)}>
            <h5 className={css(styles.highlights1, styles.highlights1_layout)}>
              {
                '你懂得順應自然，會解讀空氣的氣味與背後的意義，就像是山林裡的獨角獸，心思細膩敏銳，同時正義勇敢，緊握守護自然的使命，隨時伺機而動。'
              }
            </h5>
          </div>
          <div className={css(styles.flex_item3)}>
            <div
              onClick={() => window.open('/soul', '_self')}
              className={`${css(
                styles.cover_group1,
                styles.cover_group1_layout
              )} cursor-pointer to-more`}
            >
              <h5
                className={css(styles.highlights2, styles.highlights2_layout)}
              >
                {'五感靈魂樣貌'}
              </h5>
            </div>
          </div>
          <div className={css(styles.flex_item4)}>
            <div
              style={{
                '--src': `url(${
                  require('assets/c245b3e704bfbc9d157aae4ceedd381b.png').default
                })`
              }}
              className={css(styles.image1, styles.image1_layout)}
            />
          </div>
          <h4 className={css(styles.highlights3, styles.highlights3_layout)}>
            {'專屬於你的風味想像'}
          </h4>
          <div className={css(styles.flex_item5)}>
            <div
              className={css(
                styles.paragraph_body,
                styles.paragraph_body_layout
              )}
            >
              {
                '走入有霧的森林，肌膚觸感圍繞潮濕的小雨青苔，全身被沁涼而乾淨的雲霧洗滌。這是山林的秘境，只有受到呼召引導的你，才能看見。這一款茶在風味上偏果酸，但酸與甜是平衡共存的，當你經歷越大的風雨，所回應的回甘甜度是只有自己可以明白。'
              }
            </div>
          </div>
          <h4 className={css(styles.highlights4, styles.highlights4_layout)}>
            {'推薦給你：野溪邊的茶・果酸有機紅烏龍'}
          </h4>
          <div className={css(styles.flex_item6)}>
            <div
              className={css(
                styles.paragraph_body,
                styles.paragraph_body_layout1
              )}
            >
              {
                '這是一款能夠淨化一切的茶，口腔也好、心情也好，喝茶的當下繚繞的沁涼，能讓人擁有清靜與放鬆的思緒。'
              }
            </div>
          </div>
          <div className={css(styles.flex_item7)}>
            <div className={css(styles.flex1, styles.flex1_layout)}>
              <div className={css(styles.flex1_item)}>
                <div className={css(styles.group2, styles.group2_layout)}>
                  <div
                    className={css(
                      styles.small_text_body,
                      styles.small_text_body_layout
                    )}
                  >
                    {'風味標籤'}
                  </div>
                </div>
              </div>
              <div className={css(styles.flex1_spacer)} />
              <div className={css(styles.flex1_item1)}>
                <div
                  className={css(
                    styles.small_paragraph_body,
                    styles.small_paragraph_body_layout
                  )}
                >
                  {'百香果、莓果酒香、清新草本、黃檸檬、芬多精、酢漿草'}
                </div>
              </div>
            </div>
          </div>
          <div className={css(styles.flex_item)}>
            <div className={css(styles.group3, styles.group3_layout)}>
              <div className={css(styles.flex2, styles.flex2_layout)}>
                <div className={css(styles.flex2_item)}>
                  <div
                    className={css(
                      styles.cover_group2,
                      styles.cover_group2_layout
                    )}
                  >
                    {'茶體'}
                  </div>
                </div>
                <div className={css(styles.flex2_spacer)} />
                <div
                  className={css(
                    styles.small_text_body1,
                    styles.small_text_body1_layout
                  )}
                >
                  {'輕盈'}
                </div>
                <div className={css(styles.flex2_spacer1)} />
                <div className={css(styles.flex2_item1)}>
                  <div className={css(styles.group4, styles.group4_layout)}>
                    <div
                      style={{
                        '--src': `url(${
                          require('assets/42fc703a4713d9a90c79f00db95b39f5.svg')
                            .default
                        })`
                      }}
                      className={css(styles.decorator, styles.decorator_layout)}
                    />

                    <div className={css(styles.group5, styles.group5_layout)}>
                      <div
                        style={{
                          '--src': `url(${
                            require('assets/646bf525daf1edeb9950b56b77642fa3.svg')
                              .default
                          })`
                        }}
                        className={css(styles.img, styles.img_layout)}
                      />
                    </div>

                    <div
                      style={{
                        '--src': `url(${
                          require('assets/f14b481c58fcab163c25a090c236ccfa.svg')
                            .default
                        })`
                      }}
                      className={css(
                        styles.decorator,
                        styles.decorator_layout1
                      )}
                    />

                    <div className={css(styles.group6, styles.group6_layout)}>
                      <div
                        style={{
                          '--src': `url(${
                            require('assets/4c240fc3962b5184a3bc6287efc51ed5.svg')
                              .default
                          })`
                        }}
                        className={css(styles.img, styles.img_layout)}
                      />
                    </div>

                    <div className={css(styles.group7, styles.group7_layout)}>
                      <div
                        style={{
                          '--src': `url(${
                            require('assets/16e972c2edfb2cd5daf57357388eff0b.svg')
                              .default
                          })`
                        }}
                        className={css(styles.img, styles.img_layout)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={css(styles.flex_item9)}>
            <div className={css(styles.group8, styles.group8_layout)}>
              <div className={css(styles.flex3, styles.flex3_layout)}>
                <div className={css(styles.flex3_item)}>
                  <div
                    className={css(
                      styles.cover_group3,
                      styles.cover_group3_layout
                    )}
                  >
                    {'泡法'}
                  </div>
                </div>
                <div className={css(styles.flex3_spacer)} />
                <div className={css(styles.flex3_item1)}>
                  <div className={css(styles.flex4, styles.flex4_layout)}>
                    <div className={css(styles.flex4_item)}>
                      <div className={css(styles.flex5, styles.flex5_layout)}>
                        <div
                          style={{
                            '--src': `url(${
                              require('assets/97529223c9d20f578d71aafddd2f7372.png')
                                .default
                            })`
                          }}
                          className={css(styles.image, styles.image_layout1)}
                        />
                        <div className={css(styles.flex5_spacer)} />
                        <div
                          className={css(
                            styles.small_text_body2_box,
                            styles.small_text_body2_box_layout
                          )}
                        >
                          <div className={css(styles.small_text_body2)}>
                            <span
                              className={css(styles.small_text_body2_span0)}
                            >
                              {'200ml'}
                            </span>
                            <span
                              className={css(styles.small_text_body2_span1)}
                            >
                              {' 熱泡'}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={css(
                        styles.small_text_body3_box,
                        styles.small_text_body3_box_layout
                      )}
                    >
                      <div className={css(styles.small_text_body3)}>
                        <span className={css(styles.small_text_body3_span0)}>
                          {'茶葉 '}
                        </span>
                        <span className={css(styles.small_text_body3_span1)}>
                          {'3g'}
                        </span>
                        <span className={css(styles.small_text_body3_span2)}>
                          {' / 茶包'}
                        </span>
                        <span className={css(styles.small_text_body3_span3)}>
                          {'1'}
                        </span>
                        <span className={css(styles.small_text_body3_span4)}>
                          {'個'}
                        </span>
                      </div>
                    </div>
                    <div
                      className={css(
                        styles.small_text_body4_box,
                        styles.small_text_body4_box_layout
                      )}
                    >
                      <div className={css(styles.small_text_body4)}>
                        <span className={css(styles.small_text_body4_span0)}>
                          {'水溫：'}
                        </span>
                        <span className={css(styles.small_text_body4_span1)}>
                          {'95-98°C'}
                        </span>
                      </div>
                    </div>
                    <div
                      className={css(
                        styles.small_text_body5_box,
                        styles.small_text_body5_box_layout
                      )}
                    >
                      <div className={css(styles.small_text_body5)}>
                        <span className={css(styles.small_text_body5_span0)}>
                          {'時間：'}
                        </span>
                        <span className={css(styles.small_text_body5_span1)}>
                          {'2'}
                        </span>
                        <span className={css(styles.small_text_body5_span2)}>
                          {'分鐘'}
                        </span>
                      </div>
                    </div>
                    <div
                      className={css(
                        styles.small_text_body6_box,
                        styles.small_text_body6_box_layout
                      )}
                    >
                      <div className={css(styles.small_text_body6)}>
                        <span className={css(styles.small_text_body6_span0)}>
                          {'回沖：'}
                        </span>
                        <span className={css(styles.small_text_body6_span1)}>
                          {'3'}
                        </span>
                        <span className={css(styles.small_text_body6_span2)}>
                          {'次'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={css(styles.flex3_spacer1)} />
                <div className={css(styles.flex3_item2)}>
                  <div className={css(styles.flex6, styles.flex6_layout)}>
                    <div className={css(styles.flex6_item)}>
                      <div className={css(styles.flex7, styles.flex7_layout)}>
                        <div
                          style={{
                            '--src': `url(${
                              require('assets/7cad573eee11ee4e9f1ffc73dc4758af.png')
                                .default
                            })`
                          }}
                          className={css(styles.image, styles.image_layout2)}
                        />
                        <div className={css(styles.flex7_spacer)} />
                        <div
                          className={css(
                            styles.small_text_body7_box,
                            styles.small_text_body7_box_layout
                          )}
                        >
                          <div className={css(styles.small_text_body7)}>
                            <span
                              className={css(styles.small_text_body7_span0)}
                            >
                              {'300ml'}
                            </span>
                            <span
                              className={css(styles.small_text_body7_span1)}
                            >
                              {' 熱泡'}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={css(
                        styles.small_text_body8_box,
                        styles.small_text_body8_box_layout
                      )}
                    >
                      <div className={css(styles.small_text_body8)}>
                        <span className={css(styles.small_text_body8_span0)}>
                          {'茶葉 '}
                        </span>
                        <span className={css(styles.small_text_body8_span1)}>
                          {'3g'}
                        </span>
                        <span className={css(styles.small_text_body8_span2)}>
                          {' / 茶包'}
                        </span>
                        <span className={css(styles.small_text_body8_span3)}>
                          {'1'}
                        </span>
                        <span className={css(styles.small_text_body8_span4)}>
                          {'個'}
                        </span>
                      </div>
                    </div>
                    <div
                      className={css(
                        styles.small_text_body9_box,
                        styles.small_text_body9_box_layout
                      )}
                    >
                      <div className={css(styles.small_text_body9)}>
                        <span className={css(styles.small_text_body9_span0)}>
                          {'水溫：'}
                        </span>
                        <span className={css(styles.small_text_body9_span1)}>
                          {'95-98°C'}
                        </span>
                      </div>
                    </div>
                    <div
                      className={css(
                        styles.small_text_body10_box,
                        styles.small_text_body10_box_layout
                      )}
                    >
                      <div className={css(styles.small_text_body10)}>
                        <span className={css(styles.small_text_body10_span0)}>
                          {'時間：'}
                        </span>
                        <span className={css(styles.small_text_body10_span1)}>
                          {'3'}
                        </span>
                        <span className={css(styles.small_text_body10_span2)}>
                          {'分鐘'}
                        </span>
                      </div>
                    </div>
                    <div
                      className={css(
                        styles.small_text_body11_box,
                        styles.small_text_body11_box_layout
                      )}
                    >
                      <div className={css(styles.small_text_body11)}>
                        <span className={css(styles.small_text_body11_span0)}>
                          {'回沖'}
                        </span>
                        <span className={css(styles.small_text_body11_span1)}>
                          {'：'}
                        </span>
                        <span className={css(styles.small_text_body11_span2)}>
                          {'2'}
                        </span>
                        <span className={css(styles.small_text_body11_span3)}>
                          {'次'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={css(styles.flex_item10)}>
            <div
              onClick={() =>
                window.open(
                  'https://www.daughter-tea.com/product.aspx?openExternalBrowser=1&Id=11'
                )
              }
              className={`${css(
                styles.cover_group4,
                styles.cover_group4_layout
              )} cursor-pointer to-more`}
            >
              <h5
                className={css(styles.highlights5, styles.highlights5_layout)}
              >
                {'了解更多'}
              </h5>
            </div>
          </div>
          <div className={css(styles.flex_item11)}>
            <div
              onClick={() => window.open('/', '_self')}
              className={`${css(
                styles.cover_group5,
                styles.cover_group5_layout
              )} cursor-pointer to-home`}
            >
              <div
                className={css(styles.background, styles.background_layout)}
              />
              <h5
                className={css(styles.highlights6, styles.highlights6_layout)}
              >
                {'重新探索'}
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

SOUL5.inStorybook = true;

const styles = StyleSheet.create({
  group: {
    display: 'flex',
    background: 'var(--src) center center / cover no-repeat',
    backgroundColor: 'rgb(255,255,255)'
  },
  group_layout: {
    position: 'relative',
    minHeight: 1613,
    flexGrow: 1
  },
  group1: {
    display: 'flex',
    backgroundColor: 'rgb(231,240,230)',
    borderRadius: '0px 0px 0px 0px'
  },
  group1_layout: {
    position: 'relative',
    minHeight: 1613,
    width: 375,
    minWidth: 375,
    margin: '0px auto'
  },
  flex: {
    display: 'flex',
    flexDirection: 'column'
  },
  flex_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '53px 8px'
  },
  flex_item: {
    display: 'flex',
    flex: '0 1 30px'
  },
  component: {},
  component_layout: {
    flexGrow: 1,
    margin: '1px 8px 0px'
  },
  flex_item1: {
    display: 'flex',
    flex: '0 1 297px'
  },
  cover_group: {
    display: 'flex',
    background: 'var(--src) center center / contain no-repeat',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group_layout: {
    position: 'relative',
    minHeight: 257,
    flexGrow: 1,
    margin: '40px 8px 0px'
  },
  image: {
    background: 'var(--src) center center / contain no-repeat'
  },
  image_layout: {
    height: 152,
    width: 159,
    minWidth: 159,
    margin: '50px 55px 55px auto'
  },
  highlights: {
    display: 'flex',
    alignItems: 'center',
    font: '18px/1.79 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px',
    opacity: 0.69875
  },
  highlights_layout: {
    flex: '1 0 auto',
    margin: '15px 8px 0px'
  },
  big_title: {
    display: 'flex',
    alignItems: 'center',
    font: '500 30px/1.8 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  big_title_layout: {
    flex: '1 0 auto',
    margin: '14px 8px 0px'
  },
  flex_item2: {
    display: 'flex',
    flex: '0 1 140px'
  },
  highlights1: {
    font: '16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  highlights1_layout: {
    flexGrow: 1,
    margin: '28px 0px 0px 8px'
  },
  flex_item3: {
    display: 'flex',
    flex: '0 1 54px'
  },
  cover_group1: {
    display: 'flex',
    backgroundColor: 'rgb(94,117,111)',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group1_layout: {
    position: 'relative',
    minHeight: 44,
    flexGrow: 1,
    margin: '10px 8px 0px'
  },
  highlights2: {
    display: 'flex',
    justifyContent: 'center',
    font: '500 16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px'
  },
  highlights2_layout: {
    width: 100,
    minWidth: 100,
    margin: '8px auto'
  },
  flex_item4: {
    display: 'flex',
    flex: '0 1 302px'
  },
  image1: {
    background: 'var(--src) center center / contain no-repeat',
    borderRadius: '0px 0px 0px 0px'
  },
  image1_layout: {
    height: 257,
    flexGrow: 1,
    margin: '45px 7px 0px 8px'
  },
  highlights3: {
    display: 'flex',
    alignItems: 'center',
    font: '500 18px/1.55 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  highlights3_layout: {
    flex: '1 0 auto',
    margin: '19.5px 8px 0px'
  },
  flex_item5: {
    display: 'flex',
    flex: '0 1 115.5px'
  },
  paragraph_body: {
    font: '14px/1.57 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  paragraph_body_layout: {
    flexGrow: 1,
    margin: '5.5px 0px 0px 8px'
  },
  highlights4: {
    display: 'flex',
    alignItems: 'center',
    font: '500 18px/1.55 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  highlights4_layout: {
    flex: '1 0 auto',
    margin: '45px 8px 0px'
  },
  flex_item6: {
    display: 'flex',
    flex: '0 1 59px'
  },
  paragraph_body_layout1: {
    flexGrow: 1,
    margin: '15px 0px 0px 8px'
  },
  flex_item7: {
    display: 'flex',
    flex: '0 1 56px'
  },
  flex1: {
    display: 'flex'
  },
  flex1_layout: {
    position: 'relative',
    flexGrow: 1
  },
  flex1_item: {
    display: 'flex',
    flex: '0 1 67px'
  },
  group2: {
    display: 'flex',
    backgroundColor: 'rgb(130,169,189)',
    borderRadius: '0px 0px 0px 0px'
  },
  group2_layout: {
    position: 'relative',
    height: 20,
    flexGrow: 1,
    margin: '16px 0px 20px 8px'
  },
  small_text_body: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    letterSpacing: '0px'
  },
  small_text_body_layout: {
    height: 20,
    width: 'fit-content',
    margin: '0px 0px 0px 6px'
  },
  flex1_spacer: {
    flex: '0 0 auto',
    minWidth: 8
  },
  flex1_item1: {
    display: 'flex',
    flex: '1 1 284px'
  },
  small_paragraph_body: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_paragraph_body_layout: {
    flexGrow: 1,
    margin: '16px 2px 0px 0px'
  },
  group3: {
    display: 'flex'
  },
  group3_layout: {
    position: 'relative',
    flexGrow: 1
  },
  flex2: {
    display: 'flex'
  },
  flex2_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '0px 8px'
  },
  flex2_item: {
    display: 'flex',
    flex: '0 1 59px'
  },
  cover_group2: {
    display: 'flex',
    backgroundColor: 'rgb(130,169,189)',
    borderRadius: '0px 0px 0px 0px',
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    letterSpacing: '0px',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1px 13.999005960103204px 1px 13.999005960103204px'
  },
  cover_group2_layout: {
    position: 'relative',
    minHeight: 20,
    flexGrow: 1,
    margin: '10px 0px 0px'
  },
  flex2_spacer: {
    flex: '0 0 auto',
    minWidth: 8
  },
  small_text_body1: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body1_layout: {
    margin: '10px 0px 0px'
  },
  flex2_spacer1: {
    flex: '0 0 auto',
    minWidth: 6
  },
  flex2_item1: {
    display: 'flex',
    flex: '0 1 243px'
  },
  group4: {
    display: 'flex'
  },
  group4_layout: {
    position: 'relative',
    height: 18,
    width: 65,
    minWidth: 65,
    margin: '10px 0px 2px'
  },
  decorator: {
    background: 'var(--src) center center / contain no-repeat'
  },
  decorator_layout: {
    position: 'absolute',
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px',
    inset: '0px auto auto 0px'
  },
  group5: {
    display: 'flex',
    opacity: 0.2
  },
  group5_layout: {
    position: 'absolute',
    width: 14,
    minWidth: 14,
    margin: '0px auto',
    inset: 0
  },
  img: {
    background: 'var(--src) center center / cover no-repeat'
  },
  img_layout: {
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px 0px 1px'
  },
  decorator_layout1: {
    position: 'absolute',
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px',
    inset: '0px auto auto 13px'
  },
  group6: {
    display: 'flex',
    opacity: 0.2047374636627907
  },
  group6_layout: {
    position: 'absolute',
    width: 14,
    minWidth: 14,
    inset: '0px 13px 0px auto'
  },
  group7: {
    display: 'flex',
    opacity: 0.2047374636627907
  },
  group7_layout: {
    position: 'absolute',
    width: 14,
    minWidth: 14,
    inset: '0px 0px 0px auto'
  },
  flex_item9: {
    display: 'flex',
    flex: '0 1 110px'
  },
  group8: {
    display: 'flex'
  },
  group8_layout: {
    position: 'relative',
    flexGrow: 1
  },
  flex3: {
    display: 'flex'
  },
  flex3_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '0px 8px'
  },
  flex3_item: {
    display: 'flex',
    flex: '0 0 auto',
    minWidth: 59
  },
  cover_group3: {
    display: 'flex',
    backgroundColor: 'rgb(130,169,189)',
    borderRadius: '0px 0px 0px 0px',
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    letterSpacing: '0px',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1.5px 13.999005960103204px 1.5px 13.999005960103204px'
  },
  cover_group3_layout: {
    position: 'relative',
    height: 'min-content',
    minHeight: 20,
    flexGrow: 1,
    margin: '10px 0px 0px'
  },
  flex3_spacer: {
    flex: '0 0 auto',
    minWidth: 8
  },
  flex3_item1: {
    display: 'flex',
    flex: '0 1 94px'
  },
  flex4: {
    display: 'flex',
    flexDirection: 'column'
  },
  flex4_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '10px 0px 0px'
  },
  flex4_item: {
    display: 'flex',
    flex: '0 1 20px'
  },
  flex5: {
    display: 'flex'
  },
  flex5_layout: {
    position: 'relative',
    flexGrow: 1
  },
  image_layout1: {
    flex: '0 1 18px',
    height: 11,
    width: 18,
    minWidth: 18,
    margin: '5px 0px 4px'
  },
  flex5_spacer: {
    flex: '0 0 auto',
    minWidth: 5
  },
  small_text_body2: {
    font: '12px/1.66 "Roboto", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body2_box: {},
  small_text_body2_box_layout: {
    flex: '1 1 auto'
  },
  small_text_body2_span0: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body2_span1: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body3: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    textAlign: 'right',
    letterSpacing: '0px'
  },
  small_text_body3_box: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  small_text_body3_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body3_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body3_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body3_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body3_span3: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body3_span4: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body4: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body4_box: {},
  small_text_body4_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body4_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body4_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body5_box: {},
  small_text_body5_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body5_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body6: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body6_box: {},
  small_text_body6_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body6_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body6_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body6_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  flex3_spacer1: {
    flex: '0 0 auto',
    minWidth: 30
  },
  flex3_item2: {
    display: 'flex',
    flex: '0 1 152px'
  },
  flex6: {
    display: 'flex',
    flexDirection: 'column'
  },
  flex6_layout: {
    position: 'relative',
    width: 94,
    minWidth: 94,
    margin: '10px 0px 0px'
  },
  flex6_item: {
    display: 'flex',
    flex: '0 1 20px'
  },
  flex7: {
    display: 'flex'
  },
  flex7_layout: {
    position: 'relative',
    flexGrow: 1
  },
  image_layout2: {
    flex: '0 1 18px',
    height: 13,
    width: 18,
    minWidth: 18,
    margin: '4px 0px 3px'
  },
  flex7_spacer: {
    flex: '0 0 auto',
    minWidth: 5
  },
  small_text_body7: {
    font: '12px/1.66 "Roboto", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body7_box: {},
  small_text_body7_box_layout: {
    flex: '1 1 auto'
  },
  small_text_body7_span0: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body7_span1: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body8: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    textAlign: 'right',
    letterSpacing: '0px'
  },
  small_text_body8_box: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  small_text_body8_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body8_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body8_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body8_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body8_span3: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body8_span4: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body9: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body9_box: {},
  small_text_body9_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body9_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body9_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body10: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body10_box: {},
  small_text_body10_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body10_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body10_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body10_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body11: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body11_box: {},
  small_text_body11_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body11_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body11_span1: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body11_span2: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body11_span3: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  flex_item10: {
    display: 'flex',
    flex: '0 1 56px'
  },
  cover_group4: {
    display: 'flex',
    backgroundColor: 'rgb(94,117,111)',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group4_layout: {
    position: 'relative',
    minHeight: 44,
    flexGrow: 1,
    margin: '12px 8px 0px'
  },
  highlights5: {
    display: 'flex',
    justifyContent: 'center',
    font: '500 16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px'
  },
  highlights5_layout: {
    width: 68,
    minWidth: 68,
    margin: '8px auto'
  },
  flex_item11: {
    display: 'flex',
    flex: '0 1 60px'
  },
  cover_group5: {
    display: 'flex'
  },
  cover_group5_layout: {
    position: 'relative',
    minHeight: 44,
    flexGrow: 1,
    margin: '16px 8px 0px'
  },
  background: {
    border: '1px solid rgb(94,117,111)',
    borderRadius: '0px 0px 0px 0px'
  },
  background_layout: {
    position: 'absolute',
    height: 44,
    flexGrow: 1,
    inset: '0px 0px auto'
  },
  highlights6: {
    display: 'flex',
    justifyContent: 'center',
    font: '500 16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(94,117,111)',
    textAlign: 'center',
    letterSpacing: '0px'
  },
  highlights6_layout: {
    width: 68,
    minWidth: 68,
    margin: '8px auto'
  }
});
